(function () {
  const SLOT_KEY = "_BirdChimeSlotId";
  const DEBOUNCE_MS = 350;

  let lastSlot = null;
  let timer = null;
  let inProgress = false;

  async function fetchJSON(url, options) {
    const res = await fetch(url, {
      credentials: "same-origin",
      headers: { "Content-Type": "application/json" },
      ...options,
    });

    const text = await res.text();
    let data = null;
    try { data = text ? JSON.parse(text) : null; } catch (_) {}

    if (!res.ok) {
      throw new Error(`${url} -> ${res.status} ${res.statusText} :: ${text}`);
    }
    return data;
  }

  async function getCart() {
    return await fetchJSON("/cart.js", { method: "GET" });
  }

  async function setLineItemProperty(itemKey, quantity, properties) {
    return await fetchJSON("/cart/change.js", {
      method: "POST",
      body: JSON.stringify({
        id: itemKey,       // line item key (important)
        quantity,
        properties,
      }),
    });
  }

  async function applySlotToAllItems(slotValue) {
    const cart = await getCart();
    const items = (cart && cart.items) ? cart.items : [];

    if (!items.length) {
      console.warn("[BirdSlotSync] Cart empty, skip saving slot.");
      return;
    }

    for (const item of items) {
      const props = Object.assign({}, item.properties || {});
      if (props[SLOT_KEY] === slotValue) continue; // already set

      props[SLOT_KEY] = slotValue;
      await setLineItemProperty(item.key, item.quantity, props);
    }
  }

  function scheduleSave(slotValue, meta) {
    if (!slotValue) return;

    // prevent spamming same value
    if (slotValue === lastSlot) return;
    lastSlot = slotValue;

    if (timer) clearTimeout(timer);
    timer = setTimeout(async () => {
      if (inProgress) return;
      inProgress = true;
      try {
        console.log("[BirdSlotSync] Detected Bird slot -> saving to cart items:", { slotValue, meta });
        await applySlotToAllItems(String(slotValue));
        console.log("[BirdSlotSync] Saved slot OK:", slotValue);
      } catch (e) {
        console.error("[BirdSlotSync] FAILED saving slot:", e);
      } finally {
        inProgress = false;
      }
    }, DEBOUNCE_MS);
  }

  function looksLikeBirdCart(obj) {
    if (!obj || typeof obj !== "object") return false;
    if (!obj[SLOT_KEY]) return false;
    // your example always has these keys too:
    if (!("Delivery Day" in obj) && !("Delivery Date" in obj)) return false;
    return true;
  }

  function scanArgsForBirdCart(args, source) {
    // Bird logs: "Bird: Posted Cart", { ...object... }
    for (const a of args) {
      if (looksLikeBirdCart(a)) {
        scheduleSave(a[SLOT_KEY], {
          source,
          deliveryDay: a["Delivery Day"],
          deliveryDate: a["Delivery Date"],
          deliveryMethod: a["Delivery Method"],
          tz: a["Customer TimeZone"],
        });
        return true;
      }
      // Sometimes libs wrap objects: {something: {...}}
      if (a && typeof a === "object") {
        for (const k of Object.keys(a)) {
          const v = a[k];
          if (looksLikeBirdCart(v)) {
            scheduleSave(v[SLOT_KEY], {
              source,
              deliveryDay: v["Delivery Day"],
              deliveryDate: v["Delivery Date"],
              deliveryMethod: v["Delivery Method"],
              tz: v["Customer TimeZone"],
              wrappedUnder: k,
            });
            return true;
          }
        }
      }
    }
    return false;
  }

  // Patch console.log/info (Bird uses console.*)
  function patchConsole(methodName) {
    const orig = console[methodName];
    if (typeof orig !== "function") return;

    console[methodName] = function (...args) {
      try {
        scanArgsForBirdCart(args, "console." + methodName);
      } catch (_) {
        // never break console
      }
      return orig.apply(console, args);
    };
  }

  patchConsole("log");
  patchConsole("info");
  patchConsole("debug");

  console.log("[BirdSlotSync] Loaded. Console patched. Waiting for Bird logs...");
})();
